import React, { useState, useEffect, useContext } from 'react';
import FiltrosInicio from './FiltrosInicio';
import TablaInicio from './TablaInicio';
import PaginacionInicio from './PaginacionInicio';
import { optionsPartido } from '../datos/options';
import { AuthContext } from '../context/authContext';
import { LoadingModal } from './ui';

const TablaInicioContainer = React.forwardRef(({
    data, 
    isLoading, 
    onEditarRegistro,
    setNewEditandoId, 
    handlePreviewClick, 
    arrayEditando, 
    handleIsEditing,
    onDataLoaded,
    onLiberarEdicion,
    onSoftDelete,
    busquedaSemanticaQuery,
    setBusquedaSemanticaQuery,
    onBusquedaSemantica,
    onVerTodas,
    onAbrirBusquedaAvanzada,
    buscandoSemantico,
    resultadosSemanticos,
    onLimpiarSemantica,
    showValoracion,
    onValorar,
    onToggleFeedback,
    onReindexarSemantico,
    reindexandoSemantico
}, ref) => {
    const { role } = useContext(AuthContext);
    // Estados para los datos y la carga
    const [datosOriginales, setDatosOriginales] = useState([]);
    const [datosFiltrados, setDatosFiltrados] = useState([]);
    const [error, setError] = useState(null);

    // Estados para los filtros
    const [filters, setFilters] = useState({
        encargado_proyecto: '',
        partido_nombre: '',
        organismo_solicitante: null,
        area_responsable: '',
        tipo_subsidio: '',
        programa_lineamiento: '',
        modalidad: '',
        estado: '',
        search: ''
    });
    
    // Estado para mostrar columna Exp. de Rendición
    const [showRendicion, setShowRendicion] = useState(false);
    // Estado para el término de búsqueda
    const [searchTerm, setSearchTerm] = useState('');
    const [searchTimeout, setSearchTimeout] = useState(null);

    // Estados para la paginación
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);

    // Efecto para cargar datos iniciales
    useEffect(() => {
        console.log('📥 Datos recibidos en TablaInicioContainer:', data);
        const datosArray = Array.isArray(data) ? data : [];
        setDatosOriginales(datosArray);
        setDatosFiltrados(datosArray);
        
        // Solo llamar a onDataLoaded si hay datos y es diferente del estado anterior
        if (onDataLoaded && datosArray.length > 0) {
            console.log('🔄 Llamando a onDataLoaded con', data.length, 'registros');
            onDataLoaded(data);
        }
    }, [data]);  // Removí onDataLoaded de las dependencias para evitar bucles

    // Calcular datos paginados
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const datosArray = Array.isArray(datosFiltrados) ? datosFiltrados : [];
    const currentItems = datosArray.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(datosArray.length / itemsPerPage);

    // Manejar cambio de página
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    // Manejar cambio de items por página
    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    // Para react-select
    const handleSelectChange = (selectedOption, { name }) => {
        setFilters(prev => ({
            ...prev,
            [name]: selectedOption ? selectedOption.value : ''
        }));
    };

    // Manejar cambio en los filtros - version original
    /*const handleFilterChange = (e) => {
        const { name, value } = e.target;
        console.log("NAME  --->", name)
        console.log("VALUE --->", value)
        
        
        setFilters(prev => ({
            ...prev,
            [name]: value
        }));
    };*/
    const handleFilterChange = (e) => {

        const { name, value } = e.target;
                
        setFilters(prevFilters => {
            // 1. Clonamos el estado anterior con el nuevo valor del filtro que cambió
            const nextFilters = {
                ...prevFilters,
                [name]: value,
            };

            // 2. TIP EXTRA: Si lo que cambió fue el área responsable, 
            // reiniciamos el programa a un string vacío (o null)
            if (name === 'area_responsable') {
                nextFilters.programa_lineamiento = "";
            }

            return nextFilters;
        });

        // Resetear página a 1 cuando cambian filtros
        setCurrentPage(1);
    };

    // Limpiar filtros
    const limpiarFiltros = () => {
        setFilters({
            encargado_proyecto: '',
            partido_nombre: '',
            organismo_solicitante: null,
            area_responsable: '',
            tipo_subsidio: '',
            programa_lineamiento: '',
            modalidad: '',
            estado: '',
            search: ''            
        });
        setSearchTerm('');
        onLimpiarSemantica?.();
    };

    // Efecto para aplicar filtros
    useEffect(() => {
        const aplicarFiltros = () => {
            let tempDatos = [...datosOriginales];

            // Aplicar filtros
            if (filters.encargado_proyecto) {
                tempDatos = tempDatos.filter(item => 
                    item.encargado_proyecto === filters.encargado_proyecto
                );
            }

            if (filters.partido_nombre) {
                const partidoSeleccionado = optionsPartido.find(
                    p => p.value === filters.partido_nombre
                );
                if (partidoSeleccionado) {
                    tempDatos = tempDatos.filter(
                        item => item.partido_nombre === partidoSeleccionado.label
                    );
                }
            }

            if (filters.organismo_solicitante) {
                tempDatos = tempDatos.filter(
                    item => item.organismo_solicitante === filters.organismo_solicitante
                );
            }

            if (filters.area_responsable) {
                tempDatos = tempDatos.filter(
                    item => item.area_responsable === filters.area_responsable
                );
            }

            if (filters.tipo_subsidio) {
                tempDatos = tempDatos.filter(
                    item => item.tipo_subsidio === filters.tipo_subsidio
                );
            }
            
            if (filters.estado) {
                tempDatos = tempDatos.filter(
                    item => item.estado === filters.estado
                );
            }
            
            if (filters.programa_lineamiento) {
                tempDatos = tempDatos.filter(
                    item => item.programa_lineamiento === filters.programa_lineamiento
                );
            }

            if (filters.modalidad) {
                tempDatos = tempDatos.filter(
                    item => item.modalidad === filters.modalidad
                    /*item => {
                        // Mapear valores de la BD a nombres de etapa
                        const etapaValue = String(item.etapa || "");
                        const itemEtapa = etapaValue === "1" ? "etapa I" : etapaValue === "2" ? "etapa II" : etapaValue;                        
                        
                        if (filters.modalidad === "etapa I") {
                            return itemEtapa !== "etapa II";
                        } else if (filters.modalidad === "etapa II") {
                            return itemEtapa === "etapa II";
                        }
                        return false;
                    }*/
                );
            }

            if (filters.search) {
                const searchTerm = filters.search.toLowerCase();
                tempDatos = tempDatos.filter(item =>
                    (item.nombre_obra && item.nombre_obra.toLowerCase().includes(searchTerm)) ||
                    (item.id_partido_obra && item.id_partido_obra.toString().toLowerCase().includes(searchTerm)) ||
                    (item.array_obras_expediente && item.array_obras_expediente.some(expediente => {
                        if (!expediente || !expediente.expediente_o) {
                            return false;
                        }
                        const objeto = expediente.objeto_o;
                        if (objeto !== 'Proyecto' && objeto !== 'Rendición') {
                            return false;
                        }
                        const expedienteStr = expediente.expediente_o.toString().toLowerCase();
                        return expedienteStr === searchTerm || expedienteStr.includes(searchTerm);
                    }))
                );
            }
            // Búsqueda general (usando el searchTerm con debounce)
            /*if (searchTerm) {
                // Si el término de búsqueda es muy corto, no hacemos nada
                //if (searchTerm.length < 2) {
                  //  return;
                //}
                
                tempDatos = tempDatos.filter(item => {
                    // Primero verificamos el nombre de la obra (búsqueda parcial)
                    if (item.nombre_obra && item.nombre_obra.toLowerCase().includes(searchTerm)) {
                        return true;
                    }
                    
                    // Solo si no coincide el nombre, buscamos en los expedientes (búsqueda exacta)
                    if (item.array_obras_expediente) {
                        return item.array_obras_expediente.some(expediente => {
                            // Verificamos que sea un proyecto y tenga expediente
                            if (!expediente || expediente.objeto_o !== 'Proyecto' || !expediente.expediente_o) {
                                return false;
                            }
                            
                            // Convertimos a string y a minúsculas para la comparación
                            const expedienteStr = expediente.expediente_o.toString().toLowerCase();
                            
                            // Comparamos si el expediente es exactamente igual al término de búsqueda
                            // o si el término de búsqueda está contenido en el expediente
                            return expedienteStr === searchTerm || 
                                   expedienteStr.includes(searchTerm);
                        });
                    }
                    
                    return false;
                });
            }*/

            setDatosFiltrados(tempDatos);
            setCurrentPage(1); // Reiniciar a la primera página al aplicar filtros
        };

        /*
        if(filters.search) {
            const searchTerm= filters.search.toLowerCase();
            tempDatos = tempDatos.filter(item=>
            (item.nombre_obra && item.nombre_obra.toLowerCase().includes(searchTerm)) ||
            (item......)
            )
        }
        */

        aplicarFiltros();
    }, [filters, datosOriginales]);

    if (isLoading) {
        return <LoadingModal />;
    }

    if (error) {
        return <div className="text-red-500 text-center py-4">Error: {error}</div>;
    }

    return (
        // El pb extra deja la paginación por encima de la burbuja fija
        // "Conectar con ADMIN" (bottom-right): sin él, al llegar al pie la
        // burbuja tapaba los botones de página. En mobile la burbuja es un
        // círculo más alto, por eso pide un poco más de aire.
        <div className="w-full p-4 pb-20 md:pb-16">
            <h2 className="text-2xl font-bold mb-4">Listado de Proyectos</h2>
            
            <FiltrosInicio 
                filters={filters}
                setFilters={setFilters}
                data={datosOriginales}
                datosFiltrados={datosFiltrados}
                handleSelectChange={handleSelectChange}
                handleFilterChange={handleFilterChange}
                limpiarFiltros={limpiarFiltros}
                searchTerm={searchTerm}
                onSearchChange={(e) => handleFilterChange(e)}

                busquedaSemanticaQuery={busquedaSemanticaQuery}
                setBusquedaSemanticaQuery={setBusquedaSemanticaQuery}
                onBusquedaSemantica={onBusquedaSemantica}
                onVerTodas={onVerTodas}
                onAbrirBusquedaAvanzada={onAbrirBusquedaAvanzada}
                buscandoSemantico={buscandoSemantico}
                resultadosSemanticos={resultadosSemanticos}
                onToggleFeedback={onToggleFeedback}
                onReindexarSemantico={onReindexarSemantico}
                reindexandoSemantico={reindexandoSemantico}
                
            />
            
            <div className="flex items-center gap-4 mb-2">
                <div className="flex items-center gap-2">
                    <input
                        type="checkbox"
                        id="toggle-rendicion"
                        checked={showRendicion}
                        onChange={(e) => setShowRendicion(e.target.checked)}
                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                    />
                    <label htmlFor="toggle-rendicion" className="text-sm text-gray-700 dark:text-gray-300 cursor-pointer select-none">
                        Exp. de rendición
                    </label>
                </div>
            </div>
            <div>
                <TablaInicio 
                    data={currentItems} 
                    isLoading={isLoading}
                    onEditarRegistro={onEditarRegistro}
                    setNewEditandoId={setNewEditandoId}
                    handlePreviewClick={handlePreviewClick}
                    arrayEditando={arrayEditando}
                    handleIsEditing={handleIsEditing}
                    showRendicion={showRendicion}
                    onLiberarEdicion={onLiberarEdicion}
                    onSoftDelete={onSoftDelete}
                    showValoracion={showValoracion}
                    onValorar={onValorar}
                />
            </div>
            
            <PaginacionInicio
                currentPage={currentPage}
                totalPages={totalPages}
                itemsPerPage={itemsPerPage}
                totalItems={datosFiltrados.length}
                onPageChange={handlePageChange}
                onItemsPerPageChange={handleItemsPerPageChange}
            />
        </div>
    );
});

export default TablaInicioContainer;
